var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notices',{attrs:{"duration":7000,"position":"top","width":"100%"}}),_c('navbar'),_vm._t("default"),_c('footerbar')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }